import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { getTraceabilityRequestsQueryParams } from "@tfg/types/schemas/traceabilityRequests"

import { FilterBuilderWrapper } from "~/components/table/FilterBuilderWrapper"
import { useGetTraceabilityRequestsFilterOptions } from "~/pages/SupplierPortal/TraceabilityRequests/hooks/useGetTraceabilityRequestsFilterOptions"

interface RequestFiltersProps {
  filters: Exclude<getTraceabilityRequestsQueryParams["filters"], undefined>
  setFilters: Dispatch<
    SetStateAction<
      Exclude<getTraceabilityRequestsQueryParams["filters"], undefined>
    >
  >
}

export const RequestFilters = ({
  filters,
  setFilters,
}: RequestFiltersProps) => {
  const { t } = useTranslation(["traceability"])

  const options = useGetTraceabilityRequestsFilterOptions({
    filters,
  })
  return (
    <FilterBuilderWrapper
      title={t("filters.title")}
      searchPlaceholder={t("filters.search")}
      options={options}
      filters={filters}
      setFilters={setFilters}
    />
  )
}
